import { render, staticRenderFns } from "./fhir-period.vue?vue&type=template&id=53d53e6e&"
import script from "./fhir-period.vue?vue&type=script&lang=js&"
export * from "./fhir-period.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports